import React from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  imgPlaceholderContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.palette.grey.A100,
  },

  imgText: {
    marginBottom: "35%",
    color: theme.palette.grey.A400,
  },
}));

export default function ImagePlaceholder() {
  const { classes } = useStyles();

  return (
    <Box className={classes.imgPlaceholderContainer}>
      <Typography className={classes.imgText}>No Photo</Typography>
    </Box>
  );
}
